module.exports = __webpack_public_path__ + "static/img/login-graphic.4b32839.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login-graphic.png
// module id = FBBN
// module chunks = 8